import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import JsonBlockGenerator from '../components/JsonBlockGenerator';

export default class VvnInsurance extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <JsonBlockGenerator filename={'vvn_insurance.json'} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
